// extracted by mini-css-extract-plugin
export default {"itemsList":"CareProviderInput_itemsList__ViqXt","searchIcon":"CareProviderInput_searchIcon__43PP2"};